import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { kpeReducer } from './kpeSlice';

export const kpeStore = configureStore({
  reducer: {
    kpe: kpeReducer
  }
});

export type KpeRootState = ReturnType<typeof kpeStore.getState>;
export type KpeAppDispatch = typeof kpeStore.dispatch;

export const useKpeDispatch = () => useDispatch<KpeAppDispatch>();
export const useKpeSelector: TypedUseSelectorHook<KpeRootState> = useSelector;
